import React from 'react'
import { BlockDragHandle } from '@tradingblock/components';

export const AccountHeader = () => {
    return (<BlockDragHandle>Balances</BlockDragHandle>)
}

export default AccountHeader
